import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import ExpenseReportForm from "@components/dynamic/ExpenseReportForm";

const ExpenseByMonthReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Gastos por mes"
      backUrl="/user/dashboard-accounting"
    >
      <ExpenseReportForm />
    </PageContainer >
  );
}

export default ExpenseByMonthReport;
